export const Paths = {
    default: '/api/customer-portal/payments/bills',
};
